import { LoadingButton } from '@mui/lab';
import { Alert, Box, Stack, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';

import { CALDAV_ALLOWED_EMAIL_DOMAIN } from '../../config';
import { useCalDavStore } from '../../store';

export const CalDavSettingsForm: React.FC = observer(() => {
  const store = useCalDavStore();
  const isConfigured = store.config !== null;

  const handleLoginChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      store.setFormLogin(e.target.value);
    },
    [store],
  );

  const handlePasswordChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      store.setFormPassword(e.target.value);
    },
    [store],
  );

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();

      try {
        await store.saveConfig();
      } catch {
        // Error is handled in store
      }
    },
    [store],
  );

  const loginError = store.formLoginError;

  if (isConfigured) {
    return (
      <Stack spacing={1.5}>
        <TextField
          label="Сервер CalDav"
          value={store.formServerUrl}
          disabled
          fullWidth
          size="small"
        />

        <TextField label="Логин (email)" value={store.formLogin} disabled fullWidth size="small" />

        <Typography variant="caption" color="text.secondary">
          Для смены учётных данных удалите интеграцию и подключите заново
        </Typography>
      </Stack>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={2}>
        {store.error && (
          <Alert severity="error" onClose={() => store.clearError()}>
            {store.error}
          </Alert>
        )}

        <TextField
          label="Сервер CalDav"
          value={store.formServerUrl}
          disabled
          fullWidth
          size="small"
          helperText="Сейчас поддерживается только calendar.mail.ru"
        />

        <TextField
          label="Логин (email)"
          value={store.formLogin}
          onChange={handleLoginChange}
          placeholder={`user${CALDAV_ALLOWED_EMAIL_DOMAIN}`}
          fullWidth
          size="small"
          required
          autoComplete="email"
          error={loginError !== null}
          helperText={loginError ?? `Используйте почту в домене ${CALDAV_ALLOWED_EMAIL_DOMAIN}`}
        />

        <TextField
          label="Пароль"
          type="password"
          value={store.formPassword}
          onChange={handlePasswordChange}
          fullWidth
          size="small"
          required
          autoComplete="current-password"
          helperText="Используйте пароль для внешних приложений"
        />

        <LoadingButton
          type="submit"
          variant="contained"
          loading={store.isSaveConfigLoading}
          disabled={!store.formLogin || !store.formPassword}
          sx={{
            backgroundColor: 'var(--accent-color)',
            fontFamily: 'Montserrat, sans-serif',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: 'var(--accent-hover-color)',
            },
          }}
        >
          Подключить
        </LoadingButton>
      </Stack>
    </Box>
  );
});
